import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subpage-observacion-y-reflexion-en-la-escuela-infantil',
  templateUrl: './subpage-observacion-y-reflexion-en-la-escuela-infantil.component.html',
  styleUrls: ['./subpage-observacion-y-reflexion-en-la-escuela-infantil.component.scss']
})
export class SubpageObservacionYReflexionEnLaEscuelaInfantilComponent implements OnInit {

  constructor() { 
    window.scroll(0,0);
  }

  ngOnInit() {
  }

}
